import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation, Trans } from 'react-i18next'

import { buildStateFromParams } from '../constants/oauth'
import { fetchIdpSignUpUrl, redirectToIdpLogin } from '../actions/authActions'
import AuthLayout from './auth/common/AuthLayout'
import ButtonLink from './common/buttons/ButtonLink'
import buttonLinkStyles from './common/buttons/ButtonLink.module.scss'
import SignUpSegmentSelector from './auth/common/SignUpSegmentSelector'

import classes from './WelcomePage.module.scss'

const WelcomePage = ({ showSignUp = false }) => {
  const { t } = useTranslation()
  const communityId = localStorage.getItem('communityId')
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const location = useLocation()

  const handleSignIn = (e) => {
    e.preventDefault()
    redirectToIdpLogin(searchParams).catch(() => navigate('/login/legacy'))
  }

  const handleSignUp = (segment) => {
    fetchIdpSignUpUrl()
      .then(url => {
        const state = buildStateFromParams(segment, communityId, searchParams)
        window.location.href = `${url}&state=${encodeURIComponent(state)}`
      })
      .catch(() => toast.error(t('auth.welcomePage.signUpUnavailable')))
  }

  const handleIndividualSignUp = () => handleSignUp('individual')
  const handleFamilySignUp = () => handleSignUp('family')

  return (
    <AuthLayout selectorMode={showSignUp}>
      {showSignUp ? (
        <SignUpSegmentSelector
          onIndividualClick={handleIndividualSignUp}
          onFamilyClick={handleFamilySignUp}
        />
      ) : (
        <>
          <button
            type='button'
            onClick={() => navigate({ pathname: '/create-account', search: location.search })}
            className={classNames(buttonLinkStyles['button-link'], buttonLinkStyles.orange, classes.actionLink, 'w-100 mt-4')}
          >
            {t('auth.welcomePage.createAccount')}
          </button>

          <ButtonLink linkColor='white' navigateTo='#' onClick={handleSignIn} className={classNames(classes.actionLink, 'mt-3')} isExternal>
            {t('auth.welcomePage.logIn')}
          </ButtonLink>

          <p className={classNames(classes.poweredByText, 'my-3')}>
            <Trans
              i18nKey='auth.welcomePage.poweredBy'
              components={{
                poweredByLink: (
                  <a href='https://www.golfgenius.com' target='_blank' rel='noreferrer' className={classes.poweredByLink}>
                    Golf Genius
                  </a>
                ),
              }}
            />
          </p>
        </>
      )}
    </AuthLayout>
  )
}

WelcomePage.propTypes = {
  showSignUp: PropTypes.bool,
}

export default WelcomePage
